module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/discovery-ui/images/icons/category-icons/dj-and-lighting-gear-b005089c7786d5b8fc7b3f267646f295.png";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/discovery-ui/images/icons/category-icons/dj-and-lighting-gear.png
// module id = YjUs
// module chunks = 12 16 18